module.exports = __webpack_public_path__ + "img/orange_046.d73420d5.png";